"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActionReplace = exports.ActionMap = exports.ActionDrop = exports.IkeCollectionUpgradeActionFactory = void 0;
const __1 = require("..");
const select_list_field_1 = require("../fields/select.list.field");
class IkeCollectionUpgradeActionFactory {
    static createAction(action) {
        switch (action.action) {
            case 'map':
                return new ActionMap(action);
            case 'drop':
                return new ActionDrop(action);
            case 'replace':
                return new ActionReplace(action);
            default:
                throw new Error('Invalid action type ' + action['action']);
        }
    }
}
exports.IkeCollectionUpgradeActionFactory = IkeCollectionUpgradeActionFactory;
class ActionDrop {
    constructor(action) {
        this.reason = 'drop';
        this.targetFieldId = null;
        this.action = action;
    }
    process(oldField, newField, log) {
        newField.Mutator.clear();
        return true;
    }
}
exports.ActionDrop = ActionDrop;
class ActionMap {
    constructor(action) {
        this.reason = 'map';
        this.requiresTargetField = true;
        this.action = action;
        this.targetFieldId = action.targetFieldId;
    }
}
exports.ActionMap = ActionMap;
class ActionReplace {
    constructor(action) {
        this.reason = 'replace';
        this.requiresTargetField = true;
        this.action = action;
        this.targetFieldId = action.targetFieldId;
    }
    process(oldField, newField, log) {
        // The values already aligned no need to transform
        if (oldField.displayValue === newField.displayValue) {
            return true;
        }
        if (__1.CollectionModelFieldNestedList.isNestedListField(oldField) &&
            __1.CollectionModelFieldNestedList.isNestedListField(newField)) {
            return this.processNestedList(oldField, newField, log);
        }
        if (select_list_field_1.CollectionModelFieldSelectList.isSelectListField(oldField) &&
            select_list_field_1.CollectionModelFieldSelectList.isSelectListField(newField)) {
            return this.processSelectList(oldField, newField, log);
        }
        log.error({ fieldType: newField.schema.type }, `ActionReplace: Unsupported field type for replace '${newField.schema.type}'`);
        return false;
    }
    processNestedList(oldField, newField, log) {
        const newValue = this.action.values[oldField.displayValue];
        if (!Array.isArray(newValue)) {
            return false;
        }
        // Unset field
        if (newValue.length === 0) {
            newField.Mutator.manual(null);
            log.info({ oldValue: oldField.displayValue }, `ActionReplace: Dropped value ${__1.CollectionModelFieldNestedList.TYPE}`);
            return true;
        }
        newField.Mutator.manual(newValue);
        if (!newField.hasValue()) {
            log.error({ oldValue: oldField.displayValue, newValue: newValue.join(' > ') }, `ActionReplace: Failed to find match for ${__1.CollectionModelFieldNestedList.TYPE}`);
            return false;
        }
        return true;
    }
    processSelectList(oldField, newField, log) {
        const newValue = this.action.values[oldField.displayValue];
        if (typeof newValue !== 'string') {
            return false;
        }
        // Unset field
        if (newValue.length === 0) {
            newField.Mutator.manual(null);
            log.info({ oldValue: oldField.displayValue }, `ActionReplace: Dropped value ${__1.CollectionModelFieldNestedList.TYPE}`);
            return true;
        }
        newField.Mutator.manual(newValue);
        if (!newField.hasValue()) {
            log.error({ oldValue: oldField.displayValue, newValue }, `ActionReplace: Failed to find match for ${select_list_field_1.CollectionModelFieldSelectList.TYPE}`);
            return false;
        }
        return true;
    }
}
exports.ActionReplace = ActionReplace;
//# sourceMappingURL=collection.upgrade.action.js.map